import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import UnitTemplateSprite from "@frog/source/views/components/UnitTemplateSprite.jsx"

import units from "@frog/source/data/units.js"
import unitTemplates from "@frog/source/data/unitTemplates.js"

import "@frog/source/views/DevPaletteUI.less"

export default class DevPaletteUI {
    render() {
        if(App.game == undefined) return
        if(Dev.isPaletteShowing() != true) return
        return (
            <div class="DevPalette">
                <input class="Search" id="search-palette" type="text"
                    onKeyDown={this.onKey} onKeyUp={this.onKey}
                    placeholder="Search for a unit"/>
                <div class="UnitTemplates">
                    {Object.values(unitTemplates).map((template) => {
                        return <UnitTemplate template={template}/>
                    })}
                </div>
            </div>
        )
    }
    get onKey() {
        return (event) => {
            Dev.paletteSearchQuery = event.target.value.trim()
            event.stopPropagation()
        }
    }
}

class UnitTemplate {
    render() {
        return (
            <div class="UnitTemplate" onClick={this.onClick}
                isSelected={this.isSelected} isShown={this.isShown + ""}>
                <div class="Image Column">
                    <UnitTemplateSprite unitTemplate={this.props.template}/>
                </div>
                <div class="Name Column">{this.props.template.templateKey}</div>
            </div>
        )
    }
    get onClick() {
        return () => {
            if(Dev.selectedTemplate == this.props.template) {
                Dev.selectedTemplate = undefined
            } else {
                Dev.selectedTemplate = this.props.template
            }
        }
    }
    get isSelected() {
        return Dev.selectedTemplate == this.props.template
    }
    get isShown() {
        // If there is no search query, then
        // we don't filter anything at all.
        if(Dev.paletteSearchQuery == ""
        || Dev.paletteSearchQuery == undefined) {
            return true
        }

        if(this.props.template.templateKey != undefined
        && this.props.template.templateKey.includes(Dev.paletteSearchQuery)) {
            return true
        }
        if(this.props.template.jobKey != undefined
        && this.props.template.jobKey.includes(Dev.paletteSearchQuery)) {
            return true
        }
        if(this.props.template.randomJobKey != undefined
        && this.props.template.randomJobKey.includes(Dev.paletteSearchQuery)) {
            return true
        }
        // If it didn't pass any of the above
        // checks, then it should be filtered out!!
        return false
    }
}
